<template>
  <div>yacht</div>
</template>